import {fetch} from "utils/dataAccess";

export default async function update(item, values) {
    const response = await fetch(item['@id'], {
        method: "PUT",
        headers: new Headers({"Content-Type": "application/ld+json"}),
        body: JSON.stringify(values)
    });

    if (!response.ok) throw new Error('Failed to update notification');

    return await response.json();
}

export async function markAsRead(item) {
    return await update(item, {viewed: true});
}
